var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"quality_banner",style:({backgroundImage: 'url('+_vm.bannerData.imgUrl+')' })},[_c('div',{staticClass:"banner_text"},[_c('h1',[_vm._v(_vm._s(_vm.bannerData.title))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }